import { render } from "./Reports-page.vue?vue&type=template&id=f9bdbb44"
import script from "./Reports-page.vue?vue&type=script&lang=js"
export * from "./Reports-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__